import { defineComponent as _defineComponent } from 'vue'
import {
 EntityCustomMetadataDto,
  type EntityCustomMetadataEntryUserDto,
  type EntityCustomMetadataEntryLabelDto,
  type EntityCustomMetadataEntryStringDto,
  type EntityCustomMetadataEntryTeamDto,
} from '@/api';
import SChip from '@/components/SChip.vue';
import SAvatars from '@/components/SAvatars/SAvatars.vue';
import { getProviderIconSrc } from '@/utils/provider-icons';

interface CustomMetadataDisplayProps {
  customMetadata: Array<EntityCustomMetadataDto>;
  isSmall?: boolean;
  hasNarrowLabel?: boolean;
}

const emptyValue = '-'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMetadataDisplay',
  props: {
  customMetadata: { default: () => [] },
  isSmall: { type: Boolean, default: false },
  hasNarrowLabel: { type: Boolean, default: false }
},
  setup(__props) {





/**
 * Convert custom metadata user entry to component expected format
 * @param user
 */
const mapUserEntry = (user: EntityCustomMetadataEntryUserDto) => ({
  id: user.userId,
  name: user.name,
  email: user.login,
});

/**
 * Make sure user entries are properly typed before mapping
 * @param entries
 */
const mapUserEntries = (
  entries: (EntityCustomMetadataEntryUserDto | EntityCustomMetadataEntryLabelDto | EntityCustomMetadataEntryStringDto | EntityCustomMetadataEntryTeamDto)[],
) => entries.map((user) => mapUserEntry(user as EntityCustomMetadataEntryUserDto));

/**
 * Convert custom metadata team entry to component expected format
 * @param team
 */
const mapTeamEntry = (team: EntityCustomMetadataEntryTeamDto) => ({
  id: team.teamId,
  name: team.name,
  type: 'team',
});

/**
 * Make sure team entries are properly typed before mapping
 * @param entries
 */
const mapTeamEntries = (
  entries: (EntityCustomMetadataEntryLabelDto | EntityCustomMetadataEntryStringDto | EntityCustomMetadataEntryUserDto | EntityCustomMetadataEntryTeamDto)[],
) => entries.map((team) => mapTeamEntry(team as EntityCustomMetadataEntryTeamDto));

/**
 * Convert custom metadata entries to a displayable string
 * @param entries
 */
const entriesToDisplayableString = (
  entries: (EntityCustomMetadataEntryLabelDto | EntityCustomMetadataEntryStringDto | EntityCustomMetadataEntryUserDto | EntityCustomMetadataEntryTeamDto)[],
  type: EntityCustomMetadataDto.type,
) => {
  if (entries.length > 0) {
    if (type === EntityCustomMetadataDto.type.STRING || type === EntityCustomMetadataDto.type.LABEL) {
      return entries.map((entry) => (entry as EntityCustomMetadataEntryStringDto).value).join(', ');
    }
  }
  return emptyValue;
};

/**
 * Properly type entries as EntityCustomMetadataEntryLabelDto, for TS validation
 * @param entries
 */
const entriesAsEntityCustomMetadataEntryLabelDto = (
  entries: (EntityCustomMetadataEntryLabelDto | EntityCustomMetadataEntryStringDto | EntityCustomMetadataEntryUserDto | EntityCustomMetadataEntryTeamDto)[],
) => entries as EntityCustomMetadataEntryLabelDto[];

const isExternalCatalogMetadata = (customMetadata: EntityCustomMetadataDto) => customMetadata.lineagePlatform != null && customMetadata.lineagePlatform !== EntityCustomMetadataDto.lineagePlatform.SIFFLET;


return { __sfc: true,emptyValue, mapUserEntry, mapUserEntries, mapTeamEntry, mapTeamEntries, entriesToDisplayableString, entriesAsEntityCustomMetadataEntryLabelDto, isExternalCatalogMetadata, EntityCustomMetadataDto, SChip, SAvatars, getProviderIconSrc }
}

})